module.exports = __webpack_public_path__ + "img/easy-to-use.708788b9.svg";